import { Component, computed, inject, signal } from '@angular/core';
import { Router, RouterOutlet, NavigationEnd } from '@angular/router';
import { filter } from 'rxjs';
import { SidebarComponent } from '@shared/components/sidebar/sidebar.component';
import { UpdateNoticeComponent } from '@shared/components/update-notice/update-notice.component';
import { AppUpdateService, LayoutService } from '@core/services';

/**
 * Root App Component
 * Hosts the application shell (sidebar + content) and starts watching for deploys.
 */
@Component({
  selector: 'app-root',
  imports: [RouterOutlet, SidebarComponent, UpdateNoticeComponent],
  templateUrl: './app.html',
})
export class App {
  /** App-shell layout state (sidebar collapse). */
  protected readonly layout = inject(LayoutService);

  /** Current route (empty until the first navigation resolves) */
  protected currentRoute = signal<string>('');

  /** Show the shell/sidebar (hide on login and access-denied pages) */
  protected showShell = computed(() => {
    const route = this.currentRoute().split('?')[0].split('#')[0];
    return route !== '' && route !== '/login' && route !== '/access-denied';
  });

  constructor(private readonly _router: Router) {
    // Track route changes
    this._router.events
      .pipe(filter((event): event is NavigationEnd => event instanceof NavigationEnd))
      .subscribe((event) => {
        this.currentRoute.set(event.urlAfterRedirects);
      });

    inject(AppUpdateService).start();
  }
}
